import React from 'react';
import gql from 'graphql-tag';

import { Item2AffirmCalloutData } from '../schemas/rql';
import AffirmEstimateCTA from '@reverbdotcom/commons/src/components/affirm_estimate_cta';
import AffirmZeroPercentNudge from './affirm_estimate_cta/affirm_zero_percent_nudge';

interface IProps {
  data: Item2AffirmCalloutData.Fragment;
  simpleZeroPercentNudge?: boolean;
}

export function Item2AffirmCallout(props: IProps) {
  const { data, simpleZeroPercentNudge } = props;

  const { estimatedMonthlyPaymentPlan, pricing } = data;
  const emptyRender = !estimatedMonthlyPaymentPlan?.estimatedMonthlyPayment?.display
    || !pricing?.buyerPrice?.display;

  if (emptyRender) { return null; }

  const {
    availableTermMonths,
    estimatedMonthlyPayment,
    maxTermMonth,
    lowestAprAtMaxTerm,
    zeroPercentFinancingPlan,
    splitPay,
  } = estimatedMonthlyPaymentPlan;

  const buyerPrice = pricing.buyerPrice.display;

  if (zeroPercentFinancingPlan && !simpleZeroPercentNudge) {
    return (
      <AffirmZeroPercentNudge
        estimatedMonthlyPayment={estimatedMonthlyPayment.display}
        buyerPrice={buyerPrice}
        maxTermMonth={maxTermMonth}
        availableTermMonths={availableTermMonths}
        lowestAprAtMaxTerm={lowestAprAtMaxTerm}
      />
    );
  }

  return (
    <AffirmEstimateCTA
      estimatedMonthlyPayment={estimatedMonthlyPayment.display}
      buyerPrice={buyerPrice}
      maxTermMonth={maxTermMonth}
      availableTermMonths={availableTermMonths}
      splitPay={splitPay}
      lowestAprAtMaxTerm={lowestAprAtMaxTerm}
      zeroPercentFinancing={zeroPercentFinancingPlan}
    />
  );
}

export const Item2AffirmCalloutFragment = gql`
  fragment Item2AffirmCalloutData on Listing {
    _id
    estimatedMonthlyPaymentPlan {
      estimatedMonthlyPayment {
        display
      }
      maxTermMonth
      availableTermMonths
      lowestAprAtMaxTerm
      zeroPercentFinancingPlan
      splitPay
    },
    pricing {
      buyerPrice {
        display
      }
    },
  }
`;

export default Item2AffirmCallout;
